import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {
  REPORT_TYPES,
  TWITTERLEGENDS,
  INSIGHTLEGENDS,
  SOCIAL_SOURCES,
  INSTAINSIGHTLEGENDS,
  LOGO
} from "../../../../constants/app-constant";
import { getInlineFilterText, getSocialPlatformIdFromName, getTimelineText, getTimelineTextPosition } from "../../../../utility/common-methods";

const {
  JournalistNOARanking,
  JournalistNOATrend,
  JournalistAnalysisPrint,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  CityWiseNOARanking,
  PLATFORM_RANK,
  Reach,
  PLATFORM_TREND,
  PLATFORM_TONALITY,
  TonalityNAOTrend,
  StateWiseTrend,
  JournalistWCRanking,
  TonalityWordCount,
  StateWiseTonality,
  TonalityWCTrend,
  TopPosters,
  ShareRetweet,
  ReplyComment,
  Attachment,
  Like,
  MemberType,
  TypeOfPost,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
} = REPORT_TYPES;

const formatData = ({ datasets }) => {
  if (!datasets || !datasets.length) return;
  return datasets
    .map(({ label, data, backgroundColor }) => ({
      name: label,
      data: data && data.map((el) => parseInt(el)),
      color: backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};

const formatTwitterData = (data) => {
  if (!data) return;
  return TWITTERLEGENDS.map(({ name, color, entityname }) => {
    const newArray = data.map((x) => {
      const array = Object.keys(x).filter((el, index) => el == entityname);
      return parseInt(x[array]);
    });
    return {
      name: name,
      data: newArray,
      color: color,
    };
  });
};

const formatInsightData = (data,insightData) => {
  if (!data) return;
  if(insightData === SOCIAL_SOURCES.INSTAGRAM){
    return INSTAINSIGHTLEGENDS.map(({ name, color, entityname }) => {
      const newArray = data.map((x) => {
        const array = Object.keys(x).filter((el, index) => el == entityname);
        return parseInt(x[array]);
      });
      return {
        name: name,
        data: newArray,
        color: color,
      };
    });
  }
  else{
    return INSIGHTLEGENDS.map(({ name, color, entityname }) => {
      const newArray = data.map((x) => {
        const array = Object.keys(x).filter((el, index) => el == entityname);
        return parseInt(x[array]);
      });
      return {
        name: name,
        data: newArray,
        color: color,
      };
    });
  }
};
export const VerticalBarChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  twitterFeeds,
  insightFeeds = 0,
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  const ref = useRef();
  const labels = TWITTERLEGENDS.map(({ name }) => name);
  const insightLabels = INSIGHTLEGENDS.map(({ name }) => name);
  useEffect(() => {
    setGraphRef(ref);
  }, []);
  console.log(reportType,"line 134")
  const [lineChartData, setLineChartData] = useState({});
  const showLegends =
    graphApiResponse &&
    graphApiResponse.datasets &&
    graphApiResponse.datasets.length;
  useEffect(() => {
    redrawChart();
  }, [graphApiResponse]);

  useEffect(() => {
    formatTwitterData(data);
  }, [data]);

  const redrawChart = () => {
    const options = {
      chart: {
        type: "column",
      },
      legend: {
        enabled: !twitterFeeds && insightFeeds == 0 ? showLegends : (insightFeeds != 0?true:twitterFeeds),
        maxHeight: 65,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          chart: {
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText(to_date,from_date,dateHash)}`,
                    getTimelineTextPosition(getTimelineText(to_date,from_date,dateHash)),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)} `,
                    getTimelineTextPosition(getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
      series: !twitterFeeds && insightFeeds == 0
        ? formatData(graphApiResponse)
        : (insightFeeds != 0 && insightFeeds != undefined?formatInsightData(data,insightFeeds):formatTwitterData(data)),
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          events: {
            click: (e) => handleBarClick(e),
          },
        },
      },
      xAxis: {
        categories: !twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined)
          ? graphApiResponse.labels
          : (insightFeeds != 0 && insightFeeds != undefined?insightLabels && insightLabels.length:labels && labels.length),
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        title: {
          text: null,
        },
      },
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handleBarClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        labels: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === TonalityWCTrend ||
        reportType === MediaWiseNOARanking ||
        reportType === ThematicAnalysisTag ||
        reportType === TopPosters ||
        reportType === ShareRetweet ||
        reportType === ReplyComment ||
        reportType === Attachment ||
        reportType === Like ||
        reportType === MemberType ||
        reportType === TypeOfPost
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOATrend ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTrend ||
        reportType === EditionWiseNOATrend ||
        reportType === TonalityWCTrend
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
        if (isEmbededWidget) {
          let labelArray = label.split("[");
          routeParams.sourceName = labelArray
            .slice(0, labelArray.length - 1)
            .join("[");
        }
      }
      if (reportType === JournalistWCRanking) {
        routeParams.sourceName = label;
      }
      if (reportType === JournalistAnalysisPrint) {
        routeParams.sourceName = clickedEntity;
      }
      if (reportType === JournalistTonalityNOARanking) {
        const reporter = dataByReportType.find(
          (elm) => (elm.source_name = label)
        );
        routeParams.sourceName = reporter ? reporter.id : null;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType === ThematicAnalysisTag) {
        const clickedCategory = dataByReportType.filter(
          (elm) => elm.category_name == label
        )[0];
        routeParams.categoryId = clickedCategory.category_id;
      }
      if (reportType === ThematicAnalysisEntity) {
        const entityClicked = dataByReportType.filter(
          (elm) => elm.entity_name == label
        )[0];

        if (entityClicked && entityClicked.data && entityClicked.data.length) {
          const clickedCategory = entityClicked.data.filter(
            (elm) => elm.category_name == legend
          )[0];
          routeParams.categoryId = clickedCategory.category_id;
        }
      }

      if (reportType == REPORT_TYPES.SOV) {
        routeParams.date = label;
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === EditionWiseNOATrend
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (reportType === MediaWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == label
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === TonalityWordCount ||
        reportType === StateWiseTonality ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channelType = getSocialPlatformIdFromName(label);
      }
      if (reportType == Reach) {
        routeParams.channelType = getSocialPlatformIdFromName(legend);
      }

      if (reportType == TopPosters) {
        routeParams.from_username = label.substring(1);
      }

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.labels = legend.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

VerticalBarChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
